<template>
  <v-container fill-height fluid>
    <v-layout justify-start align-self-start>
      <v-flex xs12 md11>
        <material-card class="v-card-profile">
          <v-avatar
            slot="offset"
            class="mx-auto d-block"
            size="130">
            <v-icon size="50" color="orange">mdi-truck</v-icon>
          </v-avatar>
          <v-card-text class="text-xs-center">
            <h4 class="card-title">{{manufacturer.name}}</h4>
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-layout column class="text-xs-center">
                  <label class="text-primary font-weight-thin mb-1">{{$t('Pages.Manufacturers.model.additional_info')}}</label>
                  <p>{{manufacturer.additional_info}}</p>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-btn color="warning" round class="font-weight-light" :to="'/manufacturers/' + manufacturer.id + '/update'">{{$t('Core.Fields.edit')}}</v-btn>
            <v-btn round class="font-weight-light" href="javascript:history.go(-1)">{{$t('Core.Fields.back')}}</v-btn>
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>
    <v-layout justify-start align-self-start>
      <v-flex>
        <warehouse-transactions manufacturer :warehouses="warehouses"></warehouse-transactions>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import _ from 'lodash';
  import WarehouseTransactions from '../warehouses/WarehouseTransactions';
  export default {
    components: { WarehouseTransactions },
    data: () => ({
      manufacturer: {},
      warehouses: []
    }),
    computed: {

    },
    created () {
      this.getManufacturer(this.$route.params.id);
      this.getWarehouses();
    },
    methods: {
      getManufacturer(id){
        this.setFetching(true);
        this.repositories.manufacturer.get(id).then(response => {
          this.manufacturer = response.data.data;
        }).finally(() => {
          this.setFetching(false);
        });
      },
      getWarehouses(){
        this.repositories.warehouse.all('').then((response) => {
          this.warehouses = response.data.data.filter(el => {
            return el.id != this.$route.params.id;
          });
        })
      },
    }
  }
</script>
